import React, {Component, Fragment} from 'react'
import Button from '@material-ui/core/Button'
import { ConfirmationDialog } from 'components'
import { ExpressInterestForm } from './'
import { withRouter } from 'react-router-dom'
import { DealSheetActions, TokenActions } from 'actionsets'
import { connect } from 'react-redux'
import { DialogHandler } from 'utils'
import {FormattedMessage} from 'react-intl'

export class AllocationButton extends Component{
  constructor(props) {
    super(props)
    this.state = {}
    DealSheetActions.bindActions(this)
    TokenActions.bindActions(this, 'token')
    this.dialogHandler = new DialogHandler(this)
  }

  handleClick = async() => {
    if (await this.dialogHandler.show() !== undefined) {
      this.actions.token.verify()
      this.actions.show({id: this.props.dealSheet.id})
    }
  }

  get name() {
    return this.props.dealSheet.typeOfIssuance === 'product' ? 'Quote' : 'Allocation'
  }

  renderButton = () => {
    const {dealSheet, dealSheet: {allocationStatus : state}, staticContext, history, location, match, dispatch, ...props} = this.props

    if (state === 'available' || state === 'unavailable')
      return (
        <Button {...props} disabled={state === 'unavailable'} onClick={this.handleClick}>
          <FormattedMessage id="deal.actions.request_allocation" />
        </Button>
      )
    if (state === 'allocated')
      return (
        <Button {...props} onClick={() => history.push(`/deal_sheets/${dealSheet.id}/allocations`)}>
          <FormattedMessage id="deal.actions.request_allocation.allocated" />
        </Button>
      )
    if (state === 'pending')
      return (
        <Button {...props} style={{pointerEvents: 'none', backgroundColor: '#f5bd23'}}>
          <FormattedMessage id="deal.actions.request_allocation.pending" />
        </Button>
      )
    if (state === 'closed')
      return (
        <Button {...props} disabled>
          <FormattedMessage id="deal.actions.request_allocation.closed" />
        </Button>
      )
  }

  render = () => {
    const dialogProps = this.dialogHandler.mergedProps({onConfirm: this.state.formHandler})

    return(
      <Fragment>
        {this.renderButton()}
        <ConfirmationDialog {...dialogProps}>
          <ExpressInterestForm submitRef={formHandler => this.setState({formHandler})}/>
        </ConfirmationDialog>
      </Fragment>
    )
  }
}

export default connect(({dealSheets: {dealSheet}}) => ({dealSheet}))(withRouter(AllocationButton))